import { types } from "mobx-state-tree";
import type { Instance, SnapshotIn, SnapshotOut } from "mobx-state-tree";

export interface SpeciesInstance extends Instance<typeof Species> {}
export interface SpeciesSnapshotIn extends SnapshotIn<typeof Species> {}
export interface SpeciesSnapshotOut extends SnapshotOut<typeof Species> {}

export const Species = types.model("Species", {
  id: types.identifier,
  name: types.string,
});
